export default "__VITE_ASSET__CgWFBA3U__"